import { render, staticRenderFns } from "./distribution_member.vue?vue&type=template&id=6f1926dd"
import script from "./distribution_member.vue?vue&type=script&lang=js"
export * from "./distribution_member.vue?vue&type=script&lang=js"
import style0 from "./distribution_member.vue?vue&type=style&index=0&id=6f1926dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports